import { render } from "./SectionTitle.vue?vue&type=template&id=7ca27bfe"
const script = {}

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__